import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Phone } from 'lucide-react';
import { scrollToSection as scrollToSectionUtil } from '../utils/scrollToSection';
import '../styles/header.css';

const Header = ({ activeSection }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    // Close mobile menu FIRST so the AnimatePresence exit animation doesn't
    // block the scroll on Android WebViews. Delay scroll by one frame so the
    // menu overlay unmounts and doesn't intercept the scroll.
    setIsMobileMenuOpen(false);
    requestAnimationFrame(() => {
      scrollToSectionUtil(sectionId);
    });
  };

  const navItems = [
    { id: 'inicio', label: 'INICIO' },
    { id: 'nosotros', label: 'SOBRE NOSOTROS' },
    { id: 'servicios', label: 'SERVICIOS' },
    { id: 'faq', label: 'FAQ' },
    { id: 'contacto', label: 'CONTACTO' },
  ];

  return (
    <>
      <motion.header
        className={`header ${isScrolled ? 'scrolled' : ''}`}
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        <div className="header-container">
          <div className="header-logo" onClick={() => scrollToSection('inicio')}>
            <div className="logo-text">
              IDEAS <span className="logo-accent">COSTA BLANCA</span>
            </div>
            <div className="logo-subtitle">Reformas · Construcción · Mantenimiento</div>
          </div>

          <nav className="header-nav desktop-nav">
            {navItems.map((item) => (
              <button
                key={item.altKey || item.id}
                onClick={() => scrollToSection(item.id)}
                className={`nav-link ${activeSection === item.id ? 'active' : ''}`}
              >
                {item.label}
              </button>
            ))}
          </nav>

          <div className="header-right">
            <a href="tel:+34604150871" className="header-phone" data-testid="header-phone-link">
              <Phone size={18} />
              <span>+34 604 150 871</span>
            </a>
            <button
              className="mobile-menu-btn"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </motion.header>

      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            className="mobile-menu"
            initial={{ opacity: 0, x: '100%' }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: '100%' }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
          >
            <nav className="mobile-nav">
              {navItems.map((item, index) => (
                <motion.button
                  key={item.altKey || item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="mobile-nav-link"
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.1 }}
                >
                  {item.label}
                </motion.button>
              ))}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;